import { Injectable } from '@angular/core';
import { GlobalDataService } from '@services/global-data.service';
import { InlineManualService } from '@services/inline-manual.service';
import { ReusableService } from '@services/reusable.service';
import _ from 'lodash';

@Injectable()
export class AnalyzeFiltersService {
  constructor(
    private reusableService: ReusableService,
    private globalDataService: GlobalDataService,
    private inlineManualService: InlineManualService
  ) {}
  private nodes: any[] = [];
  private links: any[] = [];
  private listOfNodes: any;
  private view: string;

  getFilteredRows(rowData: any[], app: any, isFilterActive, impKey?: boolean, newGrid = false): any[] {
    const pinValue = !['recycled_content', 'eol_rir'].includes(app.layer);
    this.reusableService.pradicateBy(rowData, 'id');
    this.view = this.globalDataService.getMattermapView();
    rowData.forEach((element: any) => {
      const pinApplied = element.applied_pin ?? element.node_pins?.length;

      element.image = this.reusableService.getIcon(element.data_type);
      if (app?.tool === 'sankey' && element?.type === 'product') {
        element.alternativeAction = true;
      }
      const actionsNewGrid = {
        pin: !pinApplied && pinValue,
        pin_applied: pinApplied,
        alternatives: false
      };
      if (app?.tool === 'sankey' && element?.type === 'product') {
        actionsNewGrid.alternatives = true;
      }
      element.actions = actionsNewGrid;
      if (!element.hasAssociatedValues) element.hasAssociatedValues = false;
      if (impKey) {
        this.checkHasValuesAssociated(element, rowData, impKey);
      }
    });

    if (isFilterActive && impKey) {
      return rowData.filter((e) => e.hasAssociatedValues);
    }
    return rowData;
  }

  private checkHasValuesAssociated(element: any, rowData: any[], key): void {
    const parent = element.parents;
    const rawValue = element?.raw?.[key] ?? element?.[key];
    let isNumeric;

    if (this.view === 'grid') {
      isNumeric = !!Number(rawValue);
    } else {
      isNumeric = rawValue !== null && rawValue !== undefined && !isNaN(Number(rawValue));
    }
    if (isNumeric) {
      element.hasAssociatedValues = true;
      parent.forEach((e) => {
        if (rowData[e]) {
          rowData[e].hasAssociatedValues = true;
        }
      });
    }
  }

  private getlinks(): any[] {
    const listOfNodes = this.nodes.map((e) => e.id);
    this.links.forEach((e: any) => {
      e.hasAsociatedNodes = listOfNodes.includes(e.source);
    });
    return this.links.filter((e) => e.hasAsociatedNodes);
  }

  filterData(data: any, app) {
    data = _.cloneDeep(data);
    const key = data.toggle_on_field;
    if (!key) {
      return data;
    }
    this.nodes = data.nodes;
    this.links = data.links;

    this.nodes = this.getFilteredRows(this.nodes, app, true, key);
    this.links = this.getlinks();

    this.listOfNodes = {};
    this.nodes.forEach((element, index) => {
      this.listOfNodes[element.id] = index;
    });
    this.getFilteredNodes();
    this.getFilteredLinks();
    data.nodes = this.nodes;
    data.links = this.links;
    return data;
  }

  private getFilteredNodes() {
    this.nodes.forEach((element) => {
      element.id = this.listOfNodes[element.id];
      element.parents = element.parents.map((e) => this.listOfNodes[e]);
    });
  }

  private getFilteredLinks() {
    this.links.forEach((e) => {
      e.source = this.listOfNodes[e.source];
      e.target = this.listOfNodes[e.target];
    });
  }

  inlineManualConfigfunction() {
    this.inlineManualService.openInlineconfig();
    const userInfo = JSON.parse(localStorage.getItem('user_info'));
    if (userInfo?.features?.find((info) => info.feature === 'inline_manual')) {
      this.inlineManualService.openInlineManualInit();
    }
  }
}
